var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "btn bg-green wpp",
      attrs: { href: _vm.url(), target: "_blank", rel: "noopener noreferrer" }
    },
    [
      _vm._v("\n  " + _vm._s(_vm.label) + "\n  "),
      _c("img", {
        staticClass: "ml-10",
        attrs: { src: "\\static\\whatsapp_logo.svg" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48058dbf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48058dbf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/WhatsAppButton.vue
// module id = null
// module chunks = 